import CTA from '@hashicorp/react-components/src/components/call-to-action'
import classNames from 'classnames'
import s from './style.module.css'

export interface CallToActionProps {
	theme: 'blue' | 'white'
	heading: string
	content: string
	links: Array<{
		text: string
		url: string
	}>
}

export default function CallToAction({
	theme,
	heading,
	content,
	links,
}: CallToActionProps) {
	return (
		<div className={classNames(s.callToAction, s[theme])}>
			<CTA
				product="primary"
				heading={heading}
				content={content}
				links={links}
				variant="compact"
			/>
		</div>
	)
}
